<template>
  <layouts-auth>
    <layouts-auth-width>
      <div class="padding-auth-contents">
        メールアドレス確認中...
      </div>
    </layouts-auth-width>
  </layouts-auth>
</template>

<script lang="ts">
import { defineComponent, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { useStore } from '@/store/index'
import { axios, ApiResponse } from '@/plugins/axios'
import { ALERT_COLORS } from '@/store/base'
import { useRouter, useRoute } from 'vue-router'

import LayoutsAuth from '@/layouts/Auth.vue'
import LayoutsAuthWidth from '@/layouts/AuthWidth.vue'

export default defineComponent({
  components: {
    LayoutsAuth,
    LayoutsAuthWidth
  },
  setup() {
    const { t } = useI18n()
    const store = useStore()
    const router = useRouter()
    const route = useRoute()

    onMounted(() => {
      axios
        .post<ApiResponse<undefined>>(`/account/change-email/${route.params.confirmation_token}`)
        .then(response => {
          if (response.data.errorMessages) {
            store.commit('base/setAlertMessages', { messages: response.data.errorMessages, persistent: true, color: ALERT_COLORS.danger })
          } else {
            store.commit('user/setUser', response.data.payload)
            store.commit('base/setAlertMessages', { messages: [t('account.change_email.success')], persistent: true, color: ALERT_COLORS.info })
          }
          router.push('/account/change-email')
        })
    })

    return {
      t,
    }
  }
})
</script>
